<template>
  <base-section id="calculation" space="5">
    <v-container fluid>
      <v-card class="calculator-menu-card" outlined>
        <v-tabs
          v-model="tab"
          class="calculator-menu-tabs"
          background-color="white"
          show-arrows="mobile"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1" v-if="login_user === 'pegadaian.pusat'">
            <v-icon>mdi-view-dashboard-outline</v-icon>
            <span>DASHBOARD</span>
          </v-tab>
          <v-tab href="#tab-5" v-if="login_user === 'pegadaian.pusat'">
            <v-icon>mdi-shield-star-outline</v-icon>
            <span>PEGASUS</span>
          </v-tab>
          <v-tab href="#tab-2">
            <v-icon>mdi-calculator</v-icon>
            <span>KALKULATOR</span>
          </v-tab>
          <v-tab href="#tab-3">
            <v-icon>mdi-file-document-outline</v-icon>
            <span>E-POLIS</span>
          </v-tab>
          <!-- <v-tab href="#tab-4" v-if="login_user === 'pegadaian.pusat'">
            <v-icon>mdi-shield-check-outline</v-icon>
            <span>KLAIM</span>
          </v-tab>-->
          <v-tab href="#tab-6">
            <v-icon>mdi-file-search-outline</v-icon>
            <span>CEK KLAIM</span>
          </v-tab>
          <!-- <v-tab href="#tab-4">
            SUBROGASI
            <v-icon>mdi-cash-register</v-icon> -->
          <!-- </v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tab" class="calculator-tab-content">
          <v-tab-item value="tab-1">
            <app-pgddashboard />
          </v-tab-item>
          <v-tab-item value="tab-5">
            <app-pgdpegasus ref="pgdPegasus"></app-pgdpegasus>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <app-pgdcalculator />
          </v-tab-item>
          <v-tab-item value="tab-3">
            <app-pgdepolis />
          </v-tab-item>
          <!-- <v-tab-item value="tab-4">
            <app-pgdclaim />
          </v-tab-item> -->
          <v-tab-item value="tab-6">
            <app-pgdinquiry />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </base-section>
</template>
<script>
export default {
  name: "KalkulatorKontribusi",
  data: () => ({
    tab: null,
    login_user: ""
  }),
  watch: {
    tab(value) {
      if (value !== "tab-5") return;
      this.$nextTick(() => {
        if (this.$refs.pgdPegasus) {
          this.$refs.pgdPegasus.ShowDeclaration();
        }
      });
    }
  },
  created() {
    const loginId = localStorage.getItem("website_users_id");
    if (loginId === null) {
      window.location.href = "/login";
    } else {
      this.login_user = loginId;
    }
  }
};
</script>
<style scoped>
.calculator-menu-card {
  overflow: visible;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}
.calculator-menu-tabs {
  position: static;
  width: calc(100% - 32px) !important;
  max-width: 900px !important;
  margin: 16px auto 0;
  flex: 0 1 900px;
  overflow: hidden;
  border: 1px solid rgba(30, 45, 90, 0.1);
  border-radius: 18px !important;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 30px rgba(22, 32, 68, 0.12);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  animation: toolbar-enter 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}
.calculator-menu-tabs:hover {
  box-shadow: 0 14px 38px rgba(22, 32, 68, 0.17);
  transform: translateY(-2px);
}
::v-deep .calculator-menu-tabs .v-tabs-bar {
  height: 60px;
  padding: 6px;
  background: transparent !important;
}
::v-deep .calculator-menu-tabs .v-slide-group__content {
  justify-content: center;
}
::v-deep .calculator-menu-tabs .v-tab {
  position: relative;
  min-width: 160px;
  max-width: none;
  flex: 1 1 0;
  height: 48px;
  margin: 0 4px;
  padding: 0 14px;
  gap: 8px;
  border-radius: 10px;
  color: #162044 !important;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  transition: color 0.28s ease, background-color 0.28s ease,
    box-shadow 0.28s ease, transform 0.28s ease;
}
::v-deep .calculator-menu-tabs .v-tab::before {
  display: none;
}
::v-deep .calculator-menu-tabs .v-tab .v-icon {
  margin: 0;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f2f4fa;
  color: #33478b;
  font-size: 19px;
  transition: color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
}
::v-deep .calculator-menu-tabs .v-tab:hover {
  background: #f3f5fa;
  color: #24376f !important;
}
::v-deep .calculator-menu-tabs .v-tab:hover .v-icon {
  transform: translateY(-2px) rotate(-5deg) scale(1.06);
}
::v-deep .calculator-menu-tabs .v-tab--active {
  background: linear-gradient(135deg, #2e427f 0%, #1d2d60 100%) !important;
  color: #ffffff !important;
  box-shadow: inset 0 -3px 0 #f2bd22, 0 8px 18px rgba(29, 45, 96, 0.24);
  transform: translateY(-1px);
}
::v-deep .calculator-menu-tabs .v-tab--active .v-icon {
  background: rgba(255, 255, 255, 0.12);
  color: #ffd34f !important;
  box-shadow: none;
}
::v-deep .calculator-menu-tabs .v-tab--active:hover {
  color: #ffffff !important;
}
::v-deep .calculator-menu-tabs .v-tab:focus-visible {
  outline: 3px solid rgba(242, 189, 34, 0.42);
  outline-offset: -3px;
}
::v-deep .calculator-menu-tabs .v-tabs-slider {
  display: none;
}
.calculator-tab-content {
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #e8eaf1;
  border-radius: 14px;
  background: #ffffff !important;
}
.dashboard-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid rgba(21, 88, 82, 0.14);
  border-radius: 14px;
  background: #f8fbfa;
}
.dashboard-category-filter {
  display: flex;
  flex: 1 1 480px;
  flex-wrap: wrap;
  align-items: center;
  order: 1;
}
.dashboard-periods {
  display: flex;
  flex: 0 1 340px;
  gap: 10px;
  order: 3;
}
.dashboard-period-filter {
  flex: 1 1 160px;
  min-width: 145px;
}
.dashboard-toolbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}
.toolbar-search {
  width: 100%;
}
.export-actions {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 auto;
  gap: 10px;
  margin-left: auto;
  order: 2;
}
.export-btn {
  border-radius: 999px !important;
  padding: 0 20px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.4px;
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.08);
}
.export-btn--primary {
  background: linear-gradient(120deg, #08c18a, #008f5f);
  color: #ffffff !important;
}
.export-btn--secondary {
  background: linear-gradient(120deg, #ffd54f, #ff8f00);
  color: #4a2a00 !important;
}
.export-btn .v-icon {
  font-size: 18px;
}
.filter-pill {
  border-radius: 999px !important;
  border: 1px solid rgba(21, 88, 82, 0.3);
  color: #155852 !important;
  background: rgba(21, 88, 82, 0.06) !important;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.filter-pill--active {
  background: linear-gradient(120deg, #d9ae5a, #f3d08a) !important;
  color: #1b2b2f !important;
  border-color: transparent !important;
  box-shadow: 0 12px 24px rgba(217, 174, 90, 0.35);
}
@media (max-width: 1100px) {
  ::v-deep .calculator-menu-tabs .v-slide-group__content {
    justify-content: flex-start;
  }
  ::v-deep .calculator-menu-tabs .v-tab {
    min-width: 160px;
    flex: 0 0 auto;
  }
  .dashboard-category-filter {
    flex-basis: 100%;
  }
}
@media (max-width: 600px) {
  .calculator-menu-card {
    border-radius: 0 !important;
  }
  ::v-deep .calculator-menu-tabs .v-tabs-bar,
  ::v-deep .calculator-menu-tabs .v-tab {
    height: 60px;
  }
  .calculator-menu-tabs {
    width: calc(100% - 12px) !important;
    margin-top: 8px;
    border-radius: 13px !important;
  }
  ::v-deep .calculator-menu-tabs .v-tabs-bar {
    padding: 0 4px;
  }
  ::v-deep .calculator-menu-tabs .v-slide-group__content {
    justify-content: flex-start;
  }
  ::v-deep .calculator-menu-tabs .v-tab {
    min-width: 124px;
    padding: 0 10px;
    font-size: 12px;
  }
  ::v-deep .calculator-menu-tabs .v-tab .v-icon {
    width: 28px;
    height: 28px;
    font-size: 18px;
  }
  .dashboard-periods {
    flex-direction: column;
    flex-basis: 100%;
    margin-left: 0;
    order: 2;
  }
  .dashboard-period-filter {
    flex-basis: auto;
    width: 100%;
  }
  .export-actions {
    flex-basis: 100%;
    justify-content: stretch;
    margin-left: 0;
    order: 3;
  }
  .export-btn {
    flex: 1 1 100%;
  }
}
@keyframes toolbar-enter {
  from {
    opacity: 0;
    transform: translateY(-14px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .calculator-menu-tabs {
    animation: none;
    transition: none;
  }
  ::v-deep .calculator-menu-tabs .v-tab,
  ::v-deep .calculator-menu-tabs .v-tab .v-icon,
  ::v-deep .calculator-menu-tabs .v-tabs-slider {
    transition: none !important;
  }
}
.hover-pending:hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform: scale(1.03);
  box-shadow: 1px 3px 4px rgb(255 136 0) !important;
}
.vue-dropzone {
  border: 2px solid #008493;
  color: #008493;
  border-radius: 15px;
  font-size: 30px;
  font-weight: bold;
}
::v-deep .expanded-row-area td {
  background-color: #ff8800 !important;
  color: #ffffff !important;
  font-weight: bold !important;
}
::v-deep .custom-bg-area {
  padding: 0px 2px 2px 2px !important;
  background-color: #ff8800 !important;
}
::v-deep .expanded-row-area:hover td {
  background-color: #ff8800 !important;
}
::v-deep .expanded-row-area td span {
  color: #ffffff !important;
}
::v-deep .expanded-row td {
  background-color: #001f48 !important;
  color: #ffffff !important;
  font-weight: bold !important;
}
::v-deep .custom-bg {
  background-color: #001f48 !important;
  padding: 0px 2px 2px 2px !important;
}
/* Override hover state */
::v-deep .expanded-row:hover td {
  background-color: #001f48 !important;
}
::v-deep .expanded-row td span {
  color: #ffffff !important;
}
.text-detail {
  color: #001f48;
  padding: 5px 10px;
}
.text-detail-outlet {
  color: #ff8800;
  padding: 5px 10px;
}
.v-data-table tbody tr {
  cursor: pointer;
}
</style>
